module.exports = __webpack_public_path__ + "static/register-4d7ee38ecebd4e2619b46364411bd5f5.png";